import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconHistory = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.921 6.00039C13.4015 5.98348 14.8364 6.51222 15.9519 7.48572C17.0674 8.45921 17.7855 9.80933 17.9692 11.2785C18.1528 12.7476 17.7892 14.233 16.9476 15.4511C16.106 16.6692 14.8454 17.5349 13.4063 17.883C11.9672 18.231 10.4504 18.037 9.14514 17.3381C8.28911 16.8797 7.56341 16.2251 7.022 15.4365H8.90336C9.45564 15.4365 9.90336 14.9888 9.90336 14.4365C9.90336 13.8843 9.45564 13.4365 8.90336 13.4365H5.41354C5.3981 13.4362 5.38262 13.4362 5.3671 13.4365H5.00008C4.44779 13.4365 4.00008 13.8843 4.00008 14.4365V18.3398C4.00008 18.8921 4.44779 19.3398 5.00008 19.3398C5.55236 19.3398 6.00008 18.8921 6.00008 18.3398V17.368C6.62134 18.0646 7.36444 18.6532 8.20099 19.1012C9.93941 20.0321 11.9597 20.2905 13.8764 19.8269C15.7932 19.3634 17.4722 18.2104 18.5931 16.5879C19.714 14.9655 20.1983 12.9872 19.9537 11.0304C19.7091 9.07365 18.7527 7.27543 17.2669 5.97882C15.7811 4.68222 13.87 3.978 11.8981 4.00052C9.92629 4.02305 8.03173 4.77073 6.57595 6.10094C5.12017 7.43114 4.20506 9.25074 4.00522 11.2126C3.94926 11.762 4.3493 12.2528 4.89874 12.3088C5.44818 12.3647 5.93896 11.9647 5.99493 11.4153C6.14497 9.94229 6.83204 8.57612 7.92505 7.5774C9.01806 6.57867 10.4405 6.0173 11.921 6.00039ZM12.9871 8.97199C12.9871 8.4197 12.5394 7.97199 11.9871 7.97199C11.4348 7.97199 10.9871 8.4197 10.9871 8.97199V12.0946C10.9871 12.3598 11.0924 12.6142 11.28 12.8017L12.8413 14.363C13.2318 14.7536 13.865 14.7536 14.2555 14.363C14.646 13.9725 14.646 13.3393 14.2555 12.9488L12.9871 11.6804V8.97199Z"
        />
      </svg>
    );
  }
);
